var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { EMonitoringViewMode, SCOPE_SELECTORS, } from "../types";
// What the viewer chose on the Dashboard tab. The event and election tabs
// rewrite the URL, so the choice is kept in sessionStorage instead of the
// query string.
export var EMonitoringAction;
(function (EMonitoringAction) {
    EMonitoringAction["SELECT_DASHBOARD"] = "SELECT_DASHBOARD";
    EMonitoringAction["SET_SCOPE"] = "SET_SCOPE";
    EMonitoringAction["SET_WIDGET_VALUE"] = "SET_WIDGET_VALUE";
    EMonitoringAction["SET_MODE"] = "SET_MODE";
})(EMonitoringAction || (EMonitoringAction = {}));
export var INITIAL_STATE = {
    dashboardId: null,
    dashboardValues: {},
    widgetValues: {},
    mode: EMonitoringViewMode.VIEW,
};
/** A dashboard may give a widget other defaults, so picks are kept per dashboard. */
export var widgetValueKey = function (dashboardId, id) { return "".concat(dashboardId, "/").concat(id); };
var NO_VALUES = {};
/**
 * The viewer's picks for a placement. Picks were once kept by widget id; those
 * still apply to each placement of the widget until it has picks of its own.
 */
export function placementValues(state, dashboardId, placement) {
    var _a, _b;
    return ((_b = (_a = state.widgetValues[widgetValueKey(dashboardId, placement.key)]) !== null && _a !== void 0 ? _a : state.widgetValues[widgetValueKey(dashboardId, placement.widgetId)]) !== null && _b !== void 0 ? _b : NO_VALUES);
}
export function setPlacementValue(dashboardId, placement, name, value) {
    return {
        type: EMonitoringAction.SET_WIDGET_VALUE,
        key: widgetValueKey(dashboardId, placement.key),
        inherit: widgetValueKey(dashboardId, placement.widgetId),
        name: name,
        value: value,
    };
}
export function monitoringReducer(state, action) {
    var _a;
    var _b, _c;
    switch (action.type) {
        case EMonitoringAction.SELECT_DASHBOARD:
            return __assign(__assign({}, state), { dashboardId: action.dashboardId });
        case EMonitoringAction.SET_SCOPE:
            return __assign(__assign({}, state), { dashboardValues: action.scope });
        case EMonitoringAction.SET_WIDGET_VALUE: {
            var values = __assign({}, ((_c = (_b = state.widgetValues[action.key]) !== null && _b !== void 0 ? _b : (action.inherit ? state.widgetValues[action.inherit] : undefined)) !== null && _c !== void 0 ? _c : {}));
            if (action.value === null)
                delete values[action.name];
            else
                values[action.name] = action.value;
            return __assign(__assign({}, state), { widgetValues: __assign(__assign({}, state.widgetValues), (_a = {}, _a[action.key] = values, _a)) });
        }
        case EMonitoringAction.SET_MODE:
            return __assign(__assign({}, state), { mode: action.mode });
    }
}
var isTextMap = function (value) {
    return typeof value === "object" &&
        value !== null &&
        !Array.isArray(value) &&
        Object.values(value).every(function (item) { return typeof item === "string"; });
};
function isScope(value) {
    return (isTextMap(value) &&
        Object.keys(value).every(function (key) { return SCOPE_SELECTORS.includes(key); }));
}
/** The saved choice, or a fresh one; editing is never resumed from storage. */
export function loadState(storage, key) {
    var _a;
    try {
        var saved = JSON.parse((_a = storage === null || storage === void 0 ? void 0 : storage.getItem(key)) !== null && _a !== void 0 ? _a : "null");
        if (typeof saved !== "object" || saved === null)
            return INITIAL_STATE;
        var _b = saved, dashboardId = _b.dashboardId, dashboardValues = _b.dashboardValues, widgetValues = _b.widgetValues;
        if (dashboardId !== null && typeof dashboardId !== "string")
            return INITIAL_STATE;
        if (!isScope(dashboardValues))
            return INITIAL_STATE;
        if (typeof widgetValues !== "object" ||
            widgetValues === null ||
            !Object.values(widgetValues).every(isTextMap)) {
            return INITIAL_STATE;
        }
        return {
            dashboardId: dashboardId,
            dashboardValues: dashboardValues,
            widgetValues: widgetValues,
            mode: EMonitoringViewMode.VIEW,
        };
    }
    catch (_c) {
        return INITIAL_STATE;
    }
}
export function saveState(storage, key, state) {
    try {
        var dashboardId = state.dashboardId, dashboardValues = state.dashboardValues, widgetValues = state.widgetValues;
        storage === null || storage === void 0 ? void 0 : storage.setItem(key, JSON.stringify({ dashboardId: dashboardId, dashboardValues: dashboardValues, widgetValues: widgetValues }));
    }
    catch (_a) {
        // A full or disabled storage only means the choice is not remembered.
    }
}
